import React from 'react';
import styled, { css } from 'styled-components';
import { Box } from '@99designs/emu';
import { colors, spaces, typography } from '@99designs/emu/settings';

export enum RibbonSize {
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

export interface Props {
    size?: RibbonSize;
    backgroundColor?: colors.Color;
    children: React.ReactNode;
}

const sizeMapping = {
    [RibbonSize.Small]: typography.typeScale.size1,
    [RibbonSize.Medium]: typography.typeScale.size2,
    [RibbonSize.Large]: typography.typeScale.size3,
};

const StyledRibbon = styled(Box)<{ size: RibbonSize; backgroundColor: colors.Color }>`
    display: inline-block;
    color: ${colors.white};
    line-height: 1;
    padding: ${spaces['0.75bu']};
    white-space: nowrap;

    ${({ size }) => css`
        font-size: ${sizeMapping[size]}px;
    `}

    ${({ backgroundColor }) => css`
        background-color: ${colors.getColor(backgroundColor)};
    `}
`;

export function Ribbon({
    children,
    size = RibbonSize.Medium,
    backgroundColor = 'heritage',
}: Props) {
    return (
        <StyledRibbon size={size} backgroundColor={backgroundColor}>
            {children}
        </StyledRibbon>
    );
}
